__webpack_require__.p = "/robofriends/";